import React, { useEffect, useState } from "react";
import Sidebar from "./Sidebar";
import { FaBarsStaggered } from "react-icons/fa6";
import { Link } from "react-router-dom";
import axios from "axios";
import { IoSearchOutline } from "react-icons/io5";
import Loader from "../../components/Loader";
import { toast } from "react-toastify";
import AdminNav from "./AdminNav";
const KycAll = () => {
  const [sidebarOpen, setSidebarOpen] = useState(false);
  const [allKycs, setAllKycs] = useState([]);
  const [filteredKycs, setFilteredKycs] = useState([]);
  const [searchTerm, setSearchTerm] = useState("");
  const [status, setStatus] = useState("all");

  const [loading, setLoading] = useState(false);
  const toggleSidebar = () => setSidebarOpen(!sidebarOpen);
  const token = localStorage.getItem("admintoken");
  // Fetch KYC data
  useEffect(() => {
    const fetchKycsData = async () => {
      setLoading(true);
      try {
        const { data } = await axios.get(
          `${process.env.REACT_APP_API}/api/v1/kyc/kycs`,
          {
            headers: { Authorization: `Bearer ${token}` },
          }
        );
        if (data?.success) {
          const sortedKycs = data.kycs.sort(
            (a, b) => new Date(b.createdAt) - new Date(a.createdAt)
          );
          setAllKycs(sortedKycs);
          setFilteredKycs(sortedKycs);
        } else {
          toast.error(data.message);
        }
      } catch (error) {
        console.error(error);
      } finally {
        setLoading(false);
      }
    };

    fetchKycsData();
  }, []);

  // Handle Search
  const handleStatusChange = (e) => {
    const selectedStatus = e.target.value;
    setStatus(selectedStatus);

    let filtered = allKycs;

    if (selectedStatus !== "all") {
      filtered = allKycs.filter((kyc) => String(kyc.status) === selectedStatus);
    }

    // Apply search filter as well if active
    if (searchTerm.trim()) {
      const searchQuery = searchTerm.trim().toLowerCase();
      filtered = filtered.filter((kyc) => {
        const userName = `${kyc.firstName} ${kyc.lastName}`.toLowerCase();
        const userEmail = kyc.userEmail?.toLowerCase() || "";
        const userAddress = kyc.address?.toLowerCase() || "";
        const userCountry = kyc.country?.toLowerCase() || "";
        const kycDate = new Date(kyc.createdAt).toLocaleString().toLowerCase();

        return (
          userName.includes(searchQuery) ||
          userEmail.includes(searchQuery) ||
          userAddress.includes(searchQuery) ||
          userCountry.includes(searchQuery) ||
          kycDate.includes(searchQuery)
        );
      });
    }

    setFilteredKycs(filtered);
  };

  const getKYCStatus = (kycstatus) => {
    switch (kycstatus) {
      case 0:
        return "Pending";
      case 1:
        return "Verified";
      case 2:
        return "Rejected";
      default:
        return "Unknown";
    }
  };

  const getKYCClass = (kycstatus) => {
    switch (kycstatus) {
      case 0:
        return "kyc-pending";
      case 1:
        return "kyc-verified";
      case 2:
        return "kyc-rejected";
      default:
        return "";
    }
  };

  return (
    <div className="wrapper d-flex align-items-stretch">
      {loading && <Loader />}
      <Sidebar sidebarOpen={sidebarOpen} toggleSidebar={toggleSidebar} />
      <div id="content" className="px-2">
        <button
          type="button"
          id="openSidebar"
          onClick={toggleSidebar}
          className="bars-btn"
        >
          <FaBarsStaggered />
        </button>
        <AdminNav />
        <h3 className="b-clr">Pending KYC Approvals</h3>
        <div className="search-add-main">
          <div className="d-flex flex-column">
            <label className="bc-clr">Status</label>
            <select
              className="filter-inp"
              value={status}
              onChange={handleStatusChange}
            >
              <option value="all">All</option>
              <option value="0">Pending</option>
              <option value="1">Verified</option>
              <option value="2">Rejected</option>
            </select>
          </div>
          <div className="search-main">
            <input
              type="text"
              className="search-inp"
              placeholder="Search by name, email, address, country, or date..."
              value={searchTerm}
              onChange={(e) => setSearchTerm(e.target.value)}
            />
            <div className="search-icon">
              <IoSearchOutline />
            </div>
          </div>
        </div>

        <div className="tbl-main">
          <table className="simple-table">
            <thead>
              <tr>
                <th>NAME</th>
                <th>EMAIL</th>
                <th>ADDRESS</th>
                <th>COUNTRY</th>
                <th>DATE</th>
                <th>ACTIONS</th>
                <th>STATUS</th>
              </tr>
            </thead>
            <tbody>
              {filteredKycs.length > 0 ? (
                filteredKycs.map((kyc) => (
                  <tr key={kyc._id}>
                    <td>
                      {`${kyc.firstName || ""} ${kyc.lastName || ""} ${
                        kyc.companyName || ""
                      }`.trim()}
                    </td>

                    <td>{kyc.userEmail}</td>
                    <td>{kyc.address}</td>
                    <td>{kyc.country}</td>
                    <td>{new Date(kyc.createdAt).toLocaleString()}</td>
                    <td>
                      <Link
                        className="btn btn-primary"
                        to={`/dashboard/admin/kyc-details/${kyc._id}`}
                      >
                        Details
                      </Link>
                    </td>
                    <td>
                      <span className={`kyc-status ${getKYCClass(kyc.status)}`}>
                        {getKYCStatus(kyc.status)}
                      </span>
                    </td>
                  </tr>
                ))
              ) : (
                <tr>
                  <td colSpan="6">No KYC records found</td>
                </tr>
              )}
            </tbody>
          </table>
        </div>
      </div>
    </div>
  );
};

export default KycAll;
